import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles(() =>
  createStyles({
    icon: {
      justifyContent: "center",
      justifyItems: "center",
    },
    divStyled: {
      display: "flex",
      alignItems: "center",
    },
    relayContent: {
      display: "flex",
      justifyContent: "space-between",
      height: "57px",
    },
    fieldAutocompleteRelay: {
      width: "200px",
    },
  })
);

export const useToolTipStyles = makeStyles<Theme>((theme) => ({
  badge: {
    position: "relative",
    right: "-54px",
    top: "2px",
    background: "#F19949",
    fontSize: 10,
    width: "1.5vw",
    color: "#ffff",
    fontWeight: 600,
    height: 20,
    padding: "3px 7px",
    borderRadius: "5px 0px 0px 5px",
    "&:hover > div": {
      display: "block !important",
    },
  },
  toolTip: {
    zIndex: 2,
    width: 438,
    height: 105,
    flexGrow: 0,
    position: "relative",
    left: -420,
    top: 2,
    display: "none",
    borderRadius: 5,
    boxShadow: "3px 4px 4px 0 rgba(117, 122, 147, 0.12)",
    border: "solid 1px rgba(142, 148, 173, 0.15)",
    backgroundColor: "#ffff",
  },
  container: {
    display: "flex",
    padding: "25px 10px",
  },
  infos: {
    color: "#757a93",
    marginTop: -30,
    lineHeight: 1.2,
    textAlign: "left",
    paddingLeft: 5,
    fontSize: 12,
  },
  avatar: {
    height: 80,
    width: 80,
    textAlign: "center",
    position: "relative",
    top: -13,
  },
}));
